<template>
  <div name="counter">

        <div class="mt-2 p-5 mx-auto bg-white rounded-lg shadow-xl">
          <div class="flex">
            <i @click="removeFromCount" class="fas fa-minus-square count-button"></i>
              <input type="number" v-model="count" 
              class="bg-purple-100 w-1/2 h-full text-2xl mx-3 text-center rounded">
             <i @click="addToCount" class="fas fa-plus-square  count-button"></i>
          </div>
        </div>

  </div>
</template>

<script>
export default {
  name: "counter",
     props: {
      value: {type: Number, required: true},
    },
  mounted () {

  },
  data () {
    return {
      count: this.value === undefined ? 0 : this.value
    }
  },
  watch: {
    count: function (val) {
      this.$emit('countChange', val)
    },
  },
   methods: {
    formatNumber(n) {
       return (n < 10 ? '0' : '') + n
    },
    removeFromCount() {
      let value = this.count - 1
      if (value >= 0) { this.count = this.count - 1 }
      
    }, 
    addToCount() {
      this.count = this.count + 1
    }
   }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.count-button {
  @apply bg-transparent text-4xl appearance-none outline-none cursor-pointer;
}

select {
  height: 1.5em !important;
  width: auto !important;
}
</style>